import React from 'react';
import { Section } from './ui/Section';
import { Map, Clock, MessageCircle, Trophy, Sparkles, Zap, CheckCircle2, Star, Heart } from 'lucide-react';
export function Solution() {
  const features = [{
    icon: <Map className="w-7 h-7 text-white" data-id="element-420" />,
    title: 'Rutinas Visuales por Edad',
    desc: 'Versiones para 2-4, 5-8 y 9-13 años. Un mapa claro de qué sigue.',
    color: 'from-[#4AAAA5] to-[#5CBFBA]',
    featureIcon: Map
  }, {
    icon: <Clock className="w-7 h-7 text-white" data-id="element-421" />,
    title: 'Tarjetas de Transición',
    desc: "'Primero-Después' y 'Cuando-Entonces' para transiciones sin berrinche.",
    color: 'from-[#E8845F] to-[#F5A574]',
    featureIcon: Clock
  }, {
    icon: <MessageCircle className="w-7 h-7 text-white" data-id="element-422" />,
    title: 'Guiones de 10 Segundos',
    desc: 'Frases exactas para poner límites sin discutir.',
    color: 'from-[#F5C842] to-[#FFD966]',
    featureIcon: MessageCircle
  }, {
    icon: <Trophy className="w-7 h-7 text-white" data-id="element-423" />,
    title: 'Tablero de Puntos',
    desc: 'Motiva sin sobornos ni chantajes (2 estilos).',
    color: 'from-[#A78BFA] to-[#C4B5FD]',
    featureIcon: Trophy
  }];
  const benefits = ['Menos repeticiones', 'Menos negociación', 'Más cooperación sin gritos', 'Transiciones más suaves y predecibles', 'Más autonomía con el tiempo'];
  return <Section background="teal" className="relative" data-id="element-424">
      <div className="absolute top-10 right-10 text-[#4AAAA5] opacity-20" data-id="element-425">
        <Sparkles className="w-12 h-12" data-id="element-426" />
      </div>
      <div className="absolute bottom-20 left-10 text-[#F5C842] opacity-20" data-id="element-427">
        <Zap className="w-10 h-10" data-id="element-428" />
      </div>

      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-429">
        <span className="inline-flex items-center px-4 py-2 rounded-full bg-white/80 text-[#4AAAA5] font-bold tracking-wider uppercase text-sm shadow-sm mb-4" data-id="element-430">
          <Sparkles className="w-4 h-4 mr-2" data-id="element-431" />
          La Solución
        </span>
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 mt-2 mb-6" data-id="element-432">
          Kit de Rutinas Visuales{' '}
          <span className="text-[#E8845F]" data-id="element-433">Anti-Berrinches (2–13)</span>
        </h2>
        <p className="text-xl text-gray-600 leading-relaxed" data-id="element-434">
          Un sistema visual imprimible (descarga inmediata) para pegar en casa y
          transformar la mañana en una secuencia{' '}
          <span className="font-bold text-[#4AAAA5]" data-id="element-435">
            clara, visible y sostenida
          </span>
          .
        </p>
        <p className="text-gray-600 mt-4" data-id="element-436">
          <span className="font-semibold" data-id="element-437">
            Está diseñado para atacar el gatillo real:
          </span>{' '}
          <span className="text-[#E8845F] font-bold" data-id="element-438">las transiciones</span>.
        </p>
      </div>

      {/* Benefits highlight */}
      <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-8 mb-12 max-w-3xl mx-auto border-2 border-[#F5C842]/30 shadow-lg" data-id="element-439">
        <h3 className="text-xl font-bold text-center text-gray-800 mb-6 flex items-center justify-center gap-2" data-id="element-440">
          <Star className="w-5 h-5 text-[#F5C842] fill-current" data-id="element-441" />
          Lo que vas a lograr:
        </h3>
        <div className="grid sm:grid-cols-2 gap-4" data-id="element-442">
          {benefits.map((benefit, idx) => <div key={idx} className="flex items-center" data-id="element-443">
              <div className="bg-[#4AAAA5] rounded-full p-1 mr-3" data-id="element-444">
                <CheckCircle2 className="w-5 h-5 text-white" data-id="element-445" />
              </div>
              <span className="text-gray-700 font-medium" data-id="element-446">{benefit}</span>
            </div>)}
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-447">
        {features.map((feature, idx) => {
        const FeatureIcon = feature.featureIcon;
        return <div key={idx} className="bg-white p-6 rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-2 border-white/50" data-id="element-448">
              <div className="flex items-center gap-3 mb-4" data-id="element-449">
                <div className={`w-12 h-12 rounded-2xl flex items-center justify-center bg-gradient-to-br ${feature.color} shadow-lg`} data-id="element-450">
                  {feature.icon}
                </div>
                <FeatureIcon className="w-6 h-6 text-gray-300" data-id="element-451" />
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-452">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-453">
                {feature.desc}
              </p>
            </div>;
      })}
      </div>

      <div className="mt-14 text-center" data-id="element-454">
        <p className="text-xl md:text-2xl text-white font-bold bg-gradient-to-r from-[#E8845F] to-[#F5A574] inline-flex items-center gap-2 px-8 py-4 rounded-2xl shadow-lg" data-id="element-455">
          Le das a tu hijo la claridad que necesita
          <Heart className="w-5 h-5 fill-current" data-id="element-456" />
        </p>
      </div>
    </Section>;
}